module.exports = __webpack_public_path__ + "img/5-Trompet C-32 N Glatt.jpg";